/* eslint-disable brace-style */
import type {
  IRicosToolbar,
  IToolbarItemConfigTiptap,
  IToolbarSettings,
  ToolbarButtonRenderers,
} from './../../../ricos-types';
import { TOOLBARS } from './../../../editor-common';

export class EmptyToolbar implements IRicosToolbar<TOOLBARS.EMPTY> {
  readonly type = TOOLBARS.EMPTY;

  isVisible = (): boolean => {
    return false;
  };

  isEmpty(): boolean {
    return true;
  }

  getToolbarItemsConfig(_options?: { disabled: boolean } | undefined): IToolbarItemConfigTiptap[] {
    return [];
  }

  getMegaToolbarItemsConfig(
    _options?: { disabled: boolean } | undefined
  ): IToolbarItemConfigTiptap[] {
    return [];
  }

  getToolbarItemsRenderers(
    _referenceElement?: HTMLElement | null | undefined
  ): ToolbarButtonRenderers {
    return {};
  }

  getSettings(): IToolbarSettings<TOOLBARS.EMPTY> {
    return undefined;
  }

  publishButtonClick(_buttonId: string): boolean {
    return false;
  }

  publishSearch(_search: string): boolean {
    return false;
  }

  publishInstanceLoaded(): boolean {
    return false;
  }

  getVisibleFloatingButtonComponent(): undefined {
    return;
  }
}
